; require('cleave.js/dist/cleave');

; (function ($, window, document, undefined) {

    var name = 'customPhoneInput';

    function Plugin(element, options) {
        this.element = element;
        this._name = name;
        this._defaults = $.fn.customPhoneInput.defaults;
        this.options = $.extend({}, this._defaults, options);
        this.initialized = false;
        this.initialize();
    }

    $.extend(Plugin.prototype, {
        initialize: function () {
            this.buildCache();
            this.bindEvents();

            $.ajax({
                type: 'POST',
                context: this,
                url: this.options.route,
                beforeSend: function () {
                }, success: function (e) {
                    this.options.countries = e.data.countries;
                    this.options.defaultCountry = e.data.countries.filter((country) => country.id.toLowerCase() == this.options.defaultCountry.toLowerCase());
                    this.options.defaultCountry = this.options.defaultCountry.length > 0 ? this.options.defaultCountry[0] : e.data.countries.filter((country) => country.id == 'MY')[0];

                    var node = $(`<div class="input-group-prepend">
                            <a class="btn btn-sm dropdown-toggle" data-toggle="dropdown" data-country="${this.options.defaultCountry.id}" data-code="${this.options.defaultCountry.code}">
                                <span class="flag flag-sm flag-${this.options.defaultCountry.id}"></span>
                                <span>${this.options.defaultCountry.code}</span>
                            </a>
                            <div class="dropdown-menu">
                                <div class="input-group">
                                    <input type="text" class="form-control ignore" name="country-search" placeholder="Enter your country..." />
                                    <div class="input-group-append">
                                        <a href="#" data-event="country-search-clear">
                                            <i class="far fa-times"></i>
                                        </a>
                                    </div
                                </div>
                            </div>
                        </div>`);

                    this.$element.prepend(node);
                    this.$menu = node.find('.dropdown-menu');
                    this.$toggle = node.find('a[data-toggle="dropdown"]');
                    this.$input.addClass('ignore');

                    new Cleave(this.$input, {
                        delimiter: '',
                        numeral: true,
                        numeralDecimalMark: '',
                    });

                    this.populateCountries();
                    this.initialized = true;
                }
            });
        },

        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        buildCache: function () {
            this.$element = $(this.element);
            this.$input = this.$element.find('input');
        },

        bindEvents: function () {
            var plugin = this;

            plugin.$element.on('keyup', 'input[name="country-search"]', function () {
                plugin.searchCountry($(this).val());
            });

            plugin.$element.on('click', '.dropdown-item', function () {
                plugin.val({
                    'country': $(this).data('country'),
                    'callingCode': $(this).data('code'),
                }).resetSearch();
            });

            plugin.$element.on('click', 'a[data-event="country-search-clear"]', function (e) {
                e.stopPropagation();
                e.preventDefault();
                plugin.resetSearch();
            });

            plugin.$element.on('shown.bs.dropdown', function () {
                plugin.$element.find('input[name="country-search"]').trigger('focus');
                plugin.resetSearch();
            });
        },

        unbindEvents: function () {
            this.$element.off();
        },

        searchCountry: function (keyword) {
            var countries = this.options.countries;
            if (keyword.trim()) {
                keyword = keyword.toLowerCase();
                countries = countries.filter((country) => country.name.toLowerCase().includes(keyword) || country.id.toLowerCase().includes(keyword) || country.code.toLowerCase().includes(keyword));
            }

            this.populateCountries(countries);

            return this;
        },

        populateCountries: function (countries = this.options.countries) {
            this.$menu.find('.dropdown-item').remove();

            countries = countries.sort((current, previous) => {
                if (this.options.priorityCountries.includes(current.id) && this.options.priorityCountries.includes(previous.id)) {
                    return this.options.priorityCountries.indexOf(current.id) - this.options.priorityCountries.indexOf(previous.id);
                } else if (this.options.priorityCountries.includes(current.id)) {
                    return -1;
                } else if (this.options.priorityCountries.includes(previous.id)) {
                    return 1;
                } else {
                    return current.name.localeCompare(previous.name);
                }
            });

            countries.forEach(country => {
                var node = $(`<a href="#" class="dropdown-item" data-country="${country.id}" data-code="${country.code}">
                        <span class="flag flag-sm flag-${country.id}"></span>
                        <span>${country.name}</span>
                        <span>(${country.code})</span>
                    </a>`);

                this.$menu.append(node);
            });

            return this;
        },

        resetSearch: function () {
            this.$element.find('input[name="country-search"]').val('');
            $.scrollTo(0, this.$menu);
            this.populateCountries();

            return this;
        },

        isEmpty: function () {
            return !this.val()['rawInput'];
        },

        isNotEmpty: function () {
            return !!this.val()['rawInput'];
        },

        enable: function () {
            this.bindEvents();
            this.$input.attr('disabled', false);
            this.$toggle.removeClass('disabled');
        },

        disable: function () {
            this.unbindEvents();
            this.$input.attr('disabled', true);
            this.$toggle.addClass('disabled');
        },

        val: function (values = {}) {
            if ($.isEmptyObject(values)) {
                return {
                    'country': this.$toggle.data('country'),
                    'callingCode': this.$toggle.data('code'),
                    'rawInput': this.$input.val(),
                }
            }

            if (values.hasOwnProperty('country') && values.country) {
                this.$toggle.setDataAttribute('country', values.country);
                this.$toggle.find('.flag').removeClass((index, name) => (name.match(/(^|\s)flag-\S+/g) || []).join(' ')).addClass('flag-sm flag-' + values.country);
            }

            if (values.hasOwnProperty('callingCode') && values.callingCode) {
                this.$toggle.setDataAttribute('code', values.callingCode);
                this.$toggle.find('span:last-child()').html(values.callingCode);
            }

            if (values.hasOwnProperty('rawInput') && values.rawInput) {
                this.$input.val(values.rawInput);
            }

            return this;
        },
    });

    $.fn.customPhoneInput = function (options) {
        this.each(function () {
            if (!$.data(this, name)) {
                $.data(this, name, new Plugin(this, options));
            }
        });

        return this;
    };

    $.fn.customPhoneInput.defaults = {
        countries: {},
        defaultCountry: 'MY',
        priorityCountries: [],
        route: '/country',
    };
})(jQuery, window, document);
